import Typography from '@components/common/typography';
import styles from './styles.module.scss';

const MarkResolved = () => {
    // const { t } = useTranslation('modals', {
    //     keyPrefix: 'delete_wallet_account'
    // });
    return (
        <div className={styles.wrapper}>
            <Typography className={styles.title} variant="h4" alignment="center">
                Mark request as solved
            </Typography>
            <div className={styles.description}>
                Are you sure you want to mark this request as solved and close the chat? Once
                closed, you won’t be able to send new messages in this chat. However, you can reopen
                the request at any time within the next 30 days.
            </div>
        </div>
    );
};

export default MarkResolved;
